import { render, staticRenderFns } from "./AdminStatistics.vue?vue&type=template&id=55e13c9a&scoped=true&"
import script from "./AdminStatistics.vue?vue&type=script&lang=js&"
export * from "./AdminStatistics.vue?vue&type=script&lang=js&"
import style0 from "./AdminStatistics.vue?vue&type=style&index=0&id=55e13c9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e13c9a",
  null
  
)

export default component.exports